import type { CategoryContent } from '../row.js';

export const SCULPTURE: CategoryContent = {
  bscba: [
    [
      'Het David-beeld van Michelangelo werd uit één blok van welke steen gehouwen?',
      [
        'Marmer',
        'Graniet',
        'Kalksteen',
        'Zandsteen',
      ],
      0,
      'Michelangelo hakte David uit een blok wit Carrara-marmer tussen 1501 en 1504, waarmee hij marmer vestigde als de standaard voor de renaissancebeeldhouwkunst.',
    ],
    [
      'Wat is het primaire voordeel van lost-wax casting ten opzichte van direct steenhouwwerk?',
      [
        'Details worden in was verfijnd vóór het gieten',
        'Het produceert grotere beeldhouwwerken dan houwen',
        'Het vereist geen oven of smeltoven',
        'Het kan niet scheuren of verouderen in de loop der tijd',
      ],
      0,
      'Lost-wax (cire perdue) stelt beeldhouwers in staat om in kneedbare was te werken, elk detail te verfijnen en het vervolgens in brons te gieten.',
    ],
    [
      'Welke van deze is een voorbeeld van subtractieve beeldhouwkunst?',
      [
        'Een figuur uit een blok marmer hakken',
        'Klei in lagen opbouwen om een hoofd te vormen',
        'Gesmolten brons in een vorm gieten',
        'Metalen platen aan elkaar lassen',
      ],
      0,
      'Subtractieve beeldhouwkunst verwijdert materiaal om vorm te onthullen—marmer of steen beitelen. Additieve beeldhouwkunst bouwt op.',
    ],
    [
      'Auguste Rodins "The Thinker" was oorspronkelijk bedoeld als onderdeel van welk groter werk?',
      [
        '"The Gates of Hell"',
        '"The Burghers of Calais"',
        '"Monument to Balzac"',
        '"The Kiss"',
      ],
      0,
      '"The Thinker" begon als een kleine figuur die Dante Alighieri voorstelt, onderdeel van Rodins monumentale "Gates of Hell"-werk.',
    ],
    [
      'Wat is het belangrijkste kenmerk van reliëfbeeldhouwkunst?',
      [
        'Figuren springen uit een plat achtergrondoppervlak',
        'Het wordt volledig uit één steen gehouwen zonder een achtergrond',
        'Het stelt meerdere onderwerpen in het rond voor op aparte zuilen',
        'Het vereist een holle binnenkern voor stabiliteit',
      ],
      0,
      'Reliëfbeeldhouwkunst toont vormen die van een plat oppervlak uitsteken—de diepte kan variëren van ondiep tot diep uitgesneden.',
    ],
    [
      'Brons wordt voor gietwerk geprezen vanwege welke eigenschap?',
      [
        'Het vormt een beschermende patina tegen corrosie',
        'Het blijft oneindig warm aanvoelen',
        'Het wordt harder wanneer het aan zonlicht wordt blootgesteld',
        'Het weegt minder dan gelijkwaardige marmerbeeldhouwwerken',
      ],
      0,
      'Brons smelt op ~1085°C (laag genoeg voor hanteerbaar gietwerk), vangt fijne details en vormt een beschermende patina.',
    ],
    [
      'Welke beeldhouwkunsttechniek gebruikt een mal om een replica uit een originele vorm te produceren?',
      [
        'Gieten',
        'Modeleren',
        'Houwen',
        'Assemblage',
      ],
      0,
      'Bij gieten wordt vloeibaar materiaal (meestal gesmolten metaal of gips) in een mal van het origineel gegoten, dat vervolgens stolt tot een replica.',
    ],
    [
      'Gian Lorenzo Bernini\'s David verschilt van Michelangelo\'s vooral door zijn',
      [
        'een dynamische, draaiende houding in actie',
        'materiaal—brons in plaats van marmer',
        'kleinere schaal—het is een miniatuurbedelhouwwerk',
        'klassieke, symmetrische frontale oriëntatie',
      ],
      0,
      "Bernini's David (1623-24) vangt de atleet in actie, lichaam gedraaid—barokke dynamiek contrasterend met Renaissance-rust in Michelangelo's versie.",
    ],
    [
      'Welk materiaal verkiezen oude Griekse beeldhouwers voor grotere vrijstaande figuren?',
      [
        'Brons en marmer',
        'Terracotta en hout',
        'Kalksteen en klei',
        'Alleen zandsteen',
      ],
      0,
      'Klassieke Grieken goten grote bronzen (nu zeldzaam door hergebruik) en houwden marmer voor openbare monumenten en tempels.',
    ],
    [
      'Rodins "The Burghers of Calais" valt op door',
      [
        'gewone burgers afgebeeld als helden',
        'volledig uit één marmerblok gehouwen',
        'een bijbels verhaal vertegenwoordigt',
        'het gebruik van vergulde brons om licht te vangen',
      ],
      0,
      '"The Burghers" doorbreekt de conventie door zes middeleeuwse stadsbewoners als protagonisten—volledige schaal, realistisch, waardig maar niet verfraaid.',
    ],
    [
      'Welk proces verwijdert luchtbellen uit klei vóór het handmodelleren?',
      [
        'Wiggen',
        'Polijsten',
        'Patineren',
        'Temperen',
      ],
      0,
      'Wiggen—klei herhaaldelijk snijden en vouwen—verdrijft lucht die anders scheuren of explosies zou veroorzaken bij branden.',
    ],
    [
      'Welk architectonisch element is voorzien van reliëfpanelen?',
      [
        'Friezen',
        'Vensterangels',
        'Binnendeuren',
        'Dakschindels',
      ],
      0,
      'Friezen zijn doorlopende horizontale banden; metopen zijn afzonderlijke panelen. Beide versierden Griekse tempels met mythologische reliëfs.',
    ],
    [
      'Constantine Brancusi\'s beeldhouwwerken worden gekenmerkt door',
      [
        'essentiële, abstracte geometrische vormen',
        'extreem realisme en fotografisch detail',
        'intensief gebruik van kleurrijke geglazuurde tegels',
        'complexe interne mechanismen',
      ],
      0,
      'Brancusi sneed details weg tot pure vorm overbleef, pionierde in modernistische abstractie en beïnvloedde het minimalisme.',
    ],
    [
      'Welk materiaal vereist branden in een oven voor permanentie?',
      [
        'Terracotta',
        'Gips',
        'Kleislurrie',
        'Modelleerwas',
      ],
      0,
      'Ongebakken terracotta blijft bros; bakken op hoge temperatuur hardt het onherroepelijk tot duurzaam keramiek.',
    ],
    [
      'Wat is de originele bron van de "Elgin Marbles"?',
      [
        'De Parthenon in Athene',
        'Egyptische tempels in Thebe',
        'Beeldhouwwerken van het Romeinse Forum',
        'Minoeïsche paleisinruïnes op Kreta',
      ],
      0,
      '"Elgin Marbles" (5e eeuw v.Chr.) zijn marmersculpturen en friezen van de Parthenon, verwijderd door Thomas Bruce in het begin van de negentiende eeuw.',
    ],
  ],
  msc: [
    [
      'Wat onderscheidt directe beitelwerk van modernisten van Renaissance-blockeertechnieken?',
      [
        'Werken zonder voorbereidende modellen',
        'Het vereist minimaal drie jaar training in graniet',
        'Steen wordt eerst met richtlijnen geschilderd vóór beiteling',
        'Een gipsafgietsel moet worden gemaakt voordat het uiteindelijke blok wordt aangeraakt',
      ],
      0,
      'Directe beiteling vermijdt voorbereidende tekeningen, waardoor de eigenschappen van de steen mede het eindresultaat bepalen.',
    ],
    [
      'De term "contrapposto" in beeldhouwkunst verwijst naar',
      [
        'gewicht verschoven naar één been, asymmetrie scheppend',
        'de techniek om brons met metallische accenten te schilderen',
        'het praktijk om figuren in paren tegenover elkaar uit te hakken',
        'de oriëntatie van een beeldhouwwerk naar het ware noorden',
      ],
      0,
      'Contrapposto (Italiaans voor "tegen-pose") verschuift het gewicht naar één been, met een kantelende heup—een humaniserende techniek die de Renaissance overnam van de Hellenistische kunst.',
    ],
    [
      'Welke oude cultuur wordt erkend voor verfijning van de lost-wax-gietstechniek?',
      [
        'Etruskisch en Romeins',
        'Middelrijk Egyptisch',
        'Myceenisch Grieks',
        'Shang-dynastie Chinees',
      ],
      0,
      'Etrusken verfijnden lost-wax tot uitzonderlijk detail; Romeinen adopteerden en systematiseerden het voor grootschalige bronzen.',
    ],
    [
      'Barbara Hepworths doorgebroken, abstracte vormen vertegenwoordigen een afwijking van figuratieve beeldhouwkunst omdat zij',
      [
        'de leegte gelijk aan massa behandelen',
        'louter decoratief zijn in plaats van monumentaal',
        'van één vaste hoek moeten worden bekeken',
        'alleen gebruikte materialen uit hergebruik',
      ],
      0,
      "Hepworths gaten en leegtes zijn integrale vormen—kijkers kijken erdoorheen, de ruimte zelf wordt beeldhouwkunstmateriaal.",
    ],
    [
      'Wat is "modeleren" in beeldhouwpraktijk?',
      [
        'Materiaal opbouwen in klei of was',
        'Een gipsmal van een voltooid werk maken',
        'De beeldhouwwerk uit meerdere hoeken fotograferen',
        'Het oppervlak tot hoge glans polijsten',
      ],
      0,
      'Modeleren bouwt vorm op—klei, was of gips opgestapeld. Verschilt van beitelen (subtractief) en gieten (malgebaseerd).',
    ],
    [
      'Donatellos bronzen David (c. 1440) was revolutionair omdat',
      [
        'het eerste grote naakte mannelijke brons sinds de oudheid',
        'het een kind in plaats van een volwassen held afbeeldde',
        'de figuur liggend in plaats van rechtopstaand was gepositioneerd',
        'het gekleurde glazen inlegwerk verwerkte',
      ],
      0,
      "Donatello's David herleefde het klassieke naakte contrapposto—het eerste monumentale mannelijke bronzen naakt sinds Rome.",
    ],
    [
      'De "Elgin Marbles"-controverse concentreert zich op de juridische status van sculpturale onderdelen van welke structuur?',
      [
        'De Parthenon op de Akropolis van Athene',
        'De Tempel van Jupiter Capitolinus in Rome',
        'De Mausoleum van Halicarnassus',
        'De kolonnen van de bibliotheek van Alexandrië',
      ],
      0,
      'Parthenon-sculpturen werden begin negentiende eeuw verwijderd door het British Museum; Griekenland eist teruggave, terwijl het Verenigd Koninkrijk stelt dat universele toegang beter is.',
    ],
    [
      'Welke materiaaleigenschap is essentieel voor een ware "witte patina" afwerking op antieke marmersculpturen?',
      [
        'De kristallijne structuur verstrooit licht',
        'Herhaalde toepassingen van mineralolie',
        'Het oppervlak slijpen tot 5000-grit fijnheid',
        'Blootstelling aan zeewater voor decennia',
      ],
      0,
      'De transparantie en fijne kristallijne korrel van wit marmer verstrooien het licht gelijkmatig. De "gloed" komt van onderoppervlakteverstrooiing.',
    ],
    [
      'Gian Lorenzo Bernini\'s benadering van beeldhouwkunst verschilde van Renaissance-idealen in zijn nadruk op',
      [
        'theatraal drama en dynamische beweging',
        'louter symmetrische frontale oriëntatie',
        'matte oppervlakafwerkingen vermijdend polijsten',
        'alleen werken op kamer-schaal',
      ],
      0,
      'Bernini zocht barokke overdaad—spiralende vormen, overdadig draperie, dynamiek—en wees de renaissance-terughoudendheid af.',
    ],
    [
      'Welk artistiek principe stuurde neoklassieke beeldhouwers zoals Antonio Canova?',
      [
        'Navolging van Griekse en Romeinse idealen',
        'Afwijzing van al antieke voorganger voor originele uitvinding',
        'Exclusieve toepassing van abstracte, niet-representatieve vormen',
        'Verwerking van mechanische bewegende onderdelen en tandwielen',
      ],
      0,
      'Neoklassieke beeldhouwers (Canova, Thorvaldsen) herleefden antieke onderwerpen, proportionele idealen en ingehouden elegantie.',
    ],
    [
      'De techniek van "chasing" in bronzebeeldhouwkunst verwijst naar',
      [
        'metaaloppervlak afwerken met hamer en beitel',
        'het coating van brons met een chemische patina-oplossing',
        'het aan elkaar lassen van afzonderlijke gegoten stukken',
        'het schilderen van lineaire ontwerpen op het afgewerkte oppervlak',
      ],
      0,
      'Chasing gebruikt gespecialiseerde hamers en burins om randen scherp te maken, oppervlakken te structureren en gietimperfecties te verfijnen.',
    ],
    [
      'Henry Moores familie van beeldhouwwerken benadrukt de formele relatie tussen',
      [
        'de abstracte vorm en het landschap',
        'kleurtheorie en emotionele symboliek',
        'mechanische precisie en industriële herhaling',
        'heldere oppervlakken en donkere binnenholten',
      ],
      0,
      "Moores liggende figuren en moeder-kind-groepen verkennen organische abstractie, het lichaam in relatie tot geologie.",
    ],
    [
      'Welke beeldhouwkunstbeweging verwierp expliciet marmer en brons voor industriële en alledaagse gebruiksmaterialen?',
      [
        'Constructivisme',
        'Neoklassicisme',
        'Klassiek Grieks',
        'Victoriaanse academische beeldhouwkunst',
      ],
      0,
      'Constructivisten en Arte Povera gebruikten staal, beton en plastic, en bestreden zo het ideaal van het dure materiaal.',
    ],
    [
      'Wat betekent "editie" in de context van meerdere kopieën gieten?',
      [
        'Een genummerde serie gietsels uit dezelfde mal',
        'Het originele gipsmodel vóór enig gieten',
        'Een beeldhouwwerk in verschillende kleurvariaties geschilderd',
        'Een tijdelijk afgietsel vernietigd na tentoonstelling',
      ],
      0,
      'Edities (bijv. "2 van 8") stellen schaarste en authenticiteit vast—gieterijen beperken hoeveel gegoten stukken.',
    ],
    [
      'Tilman Riemenschneiders laat-gotische houten beeldhouwwerken zijn geprezen voor hun',
      [
        'ingewikkelde ondersnijding en vloeiende draperie',
        'gebruik van heldere emailverf en gilverdozing',
        'abstracte geometrische vereenvoudiging',
        'levensgrote schaal en menselijke anatomische nauwkeurigheid',
      ],
      0,
      "Riemenschneiders houtsnijdingen vertonen dicht uitgesneden draperie met diepe ondersnijding en scherpe schaduwen.",
    ],
  ],
  phd: [
    [
      'Herontdekking van Egyptische blokstatueconventies beïnvloedde modernistische abstractie door welk sleutelbeeldhouwkunstprincipe?',
      [
        'Compacte, kubieke vormen die de figuur comprimeren',
        'Exclusief gebruik van kalksteen als materiaal',
        'Vereist dat alle beeldhouwwerken naar het oosten wijzen',
        'Verbod op afbeelding van individuele identiteit',
      ],
      0,
      'Brancusi, Henry Moore en anderen adopteerden Egyptische blokstatue\'s reductie van het lichaam in essentiële geometrische volumes.',
    ],
    [
      'In het lost-wax-proces, welk structureel probleem noodzaakt de "kern" en "pinnen" (of "sprues")?',
      [
        'Zij voorkomen dat de binnenmal verschuift',
        'Zij zijn louter decoratief en optioneel',
        'Zij stellen waterafvoer na gieten mogelijk',
        'Zij dienen als aanhechtingspunten voor verguldwerk',
      ],
      0,
      'De keramische kern houdt de inwendige malholte op zijn plaats; pinnen verankeren hem, wat een gelijkmatige metaalstroom garandeert.',
    ],
    [
      'De klassicistische beweging van vroeg 19e-eeuws Scandinavië stelde welk esthetisch principe in met reactie op Napoleontische overdaad?',
      [
        'Griekse strengheid en geometrische helderheid',
        'Barokse emotionele overdadigheid en dynamische beweging',
        'Middeleeuwse herleving en gotische ornamenten',
        'Oosterse en niet-westerse formele bronnen',
      ],
      0,
      'Het Scandinavische classicisme kanaliseerde politieke bezorgdheid via strenge Griekse vormen, en stelde terughoudendheid gelijk aan verlichtingswaarden.',
    ],
    [
      'Welke conserveringsuitdaging ondergaan bronzen beeldhouwwerken op cellulair niveau wanneer ze worden blootgesteld aan "bronsziekte"?',
      [
        'Corrosie door koperchloride verzwakt het metaal',
        'De patina vervaagt en verliest kleur',
        'Het oppervlak wordt te glad om vast te houden',
        'Interne malkernen zetten uit en doen het brons scheuren',
      ],
      0,
      'Bronsziekte (koperchloride) is actieve corrosie; hernieuwde vochtblootstelling kan de corrosie zich intern laten verspreiden en het object vernietigen.',
    ],
    [
      'Hoe weken expressionistische beeldhouwers van vroeg 20e-eeuws Duitsland af van hun Rodin-beïnvloede voorgangers?',
      [
        'Vervormde verhoudingen en ruwe oppervlaktextuur',
        'Zij verlaten brons volledig voor steen',
        'Zij verwierpen alle figuratieve beeldtaal voor zuivere abstractie',
        'Zij keerden terug naar Renaissance-idealen van schoonheid',
      ],
      0,
      'Duitse expressionisten verdraaiden anatomie, ruwden oppervlakken op en versterkten psychologische intensiteit—Rodins vormvrijheid tegenover humanisme.',
    ],
    [
      'De techniek van "troubadour", beoefend door latere middeleeuwse en Renaissancebeeldhouwers, betrof',
      [
        'gezichten in hoog reliëf, rest in schetsvorm',
        'het schilderen van uitgewerkte kleding op voltooide marmerfiguren',
        'het creëren van holle bronzen schalen voor processies',
        'het inbedden van halfedelstenen in marmer ter suggestie van sieraad',
      ],
      0,
      'Troubadour behandelde portretgezichten in hoog detail, terwijl draperie en lichaam werden samengevat—gelijkenis kreeg voorrang boven volledige formele uitwerking.',
    ],
    [
      'In de vroege Renaissance, hoe functioneerde de kunstenaarscartoon in relatie tot beeldhouwuitvoering?',
      [
        'Een voorbereidende tekening om het houwen te sturen',
        'Het was een humoristisch schets onverwant aan het voltooide werk',
        'Het verving de noodzaak voor voorbereidingsmodellen',
        'Het werd als decoratieve verf op het voltooide beeldhouwwerk aangebracht',
      ],
      0,
      'Renaissance-cartoons (geschaalde tekeningen) werden op de steen overgebracht om het houwproces te sturen, voordat het gedetailleerde snijwerk begon.',
    ],
    [
      'Hoe stelde de ontwikkeling van ijzer- en staalbeeldhouwkunst in de 20e eeuw de materiaalhiërarchie van beeldhouwkunst ter discussie?',
      [
        'IJzers treksterkte maakte open, lineaire vormen mogelijk',
        'Staal werd duurder dan brons, status verhogend',
        'IJzers roestgevoeligheid maakte het ongeschikt voor buitenwerk',
        'Lassen vereiste dat beeldhouwers eerst engineers waren',
      ],
      0,
      'De sterkte en lasbaarheid van staal maakten constructies met open, luchtige ruimtes mogelijk in plaats van houwen—een conceptuele revolutie.',
    ],
    [
      'Wat articuleerde het "waarheid-naar-materiaal"-principe in modernistische beeldhouwtheorie?',
      [
        'Elk materiaals eigenschappen zouden de vorm sturen',
        'Alle materialen zijn functioneel equivalent met juiste afwerking',
        'Het duurste materiaal produceert altijd de beste beeldhouwwerk',
        'Beeldhouwwerken zouden verbergen welk materiaal zij zijn gemaakt',
      ],
      0,
      'Waarheid-naar-materiaal (Hepworth, Moore, Brancusi) weigerde kunstgrepen te verhullen: de adering van marmer, het gietproces van brons—de eigenheid van het materiaal werd blootgelegd.',
    ],
    [
      'Welk Hellenistisch beeldhouwwerk exemplifieerde "pathos"-formalisme door gecomprimeerde, dynamische spierwerk en psychologische intensiteit?',
      [
        'Laokoons verdraaide lichamen',
        'Nike van Samothrace sereen opgeheven pose',
        'Venus de Milo klassieke contrapposto',
        'Doryphoros geïdealiseerde atletieke jeugd',
      ],
      0,
      'Laokoon en zijn zonen—slangengewikkeld, kronkelend—belichamen het Hellenistische drama: anatomische vervorming en pijnlijke uitdrukking intensiveren de emotionele impact.',
    ],
    [
      'Hoe veranderde Renaissance-anatomisten invloed op beeldhouwers de afbeelding van het menselijk lichaam in vergelijking met middeleeuwse conventies?',
      [
        'Nauwkeurige anatomische kennis verving geestelijke idealisering',
        'Middeleeuwse figuren werden meer abstract en minder naturalistisch',
        'Anatomische studie werd door de Kerk verboden',
        'Renaissancebeeldhouwers negeerden het lichaam geheel voor abstracte vormen',
      ],
      0,
      'Renaissance-studie van lijken en anatomie (Leonardo, Michelangelo) produceerde overtuigende spierwerk, verkorting en dynamische pose.',
    ],
    [
      'Welke rol speelde de "vervangingsmal"-techniek in versnelling van Renaissancebronzeproductie?',
      [
        'Aparte mallen per lichaamsdeel, gegoten en samengevoegd',
        'Het stelde beeldhouwers in staat om sneller te beitelen met mechanische gereedschappen',
        'Het elimineerde de noodzaak voor een gietoven',
        'Het was louter decoratief zonder praktische functie',
      ],
      0,
      'Stukmal stelde onderdelen (hoofd, armen, romp, benen) in staat om onafhankelijk gegoten en daarna aan elkaar gelast te worden, wat de productie versnelde.',
    ],
    [
      'Op welke manier beïnvloedde Barbizon-beeldhouwers\' betrokkenheid bij landschapsrealisme 19e-eeuwse openbare monumenten?',
      [
        'Zij verankerden figuren in natuurlijk terrein',
        'Zij verwierpen alle figuratieve beeldhouwkunst voor alleen landschappen',
        'Zij elimineerden het menselijke figuur geheel uit openbare kunst',
        'Zij vereisten monumenten uit lokale steen gehouwen',
      ],
      0,
      'Barbizon-beeldhouwers (Mène, Fremiet) plaatsten dieren en figuren in geloofwaardige landschapsomgevingen, en grondden monumenten zo in een natuurlijke setting.',
    ],
    [
      'Hoe functioneert het "grondvlak" als compositorisch element in Henry Moores abstracte beeldhouwwerken?',
      [
        'Een actief veld voor vorm en negatieve ruimte',
        'Het is zuiver functioneel om kanteling te voorkomen',
        'Moore verhief beeldhouwwerken altijd op hoge voetstukken',
        'Het grondvlak is irrelevant voor het werk\'s betekenis',
      ],
      0,
      'Moore betrok het grondvlak opzettelijk: figuren nestelen zich erin of reiken eruit omhoog, waardoor de aarde zelf deel wordt van de formele compositie.',
    ],
    [
      'Welk conserveringsprincipe geldt voor structurele stabilisering van antieke marmersculpturen gebroken langs korrellijnen?',
      [
        'Lijmen moet omkeerbaar en zwakker dan de steen zijn',
        'Elke spleet moet permanent gevuld worden met gekleurde epoxy',
        'Gebroken marmer kan niet gerepareerd worden',
        'Moderne beton is het beste bindmiddel',
      ],
      0,
      'Omkeerbaarheid is kardinaal: lijmen moeten zonder beschadiging losgemaakt kunnen worden, ingeval toekomstige conservering nodig is.',
    ],
  ],
  professor: [
    [
      'Het "paragone"-argument van Renaissancebeeldhouwers stelde de superioriteit van driedimensionale vorm boven schildering gesteld op welk epistemologisch uitgangspunt?',
      [
        'Zijn fysieke soliditeit en ruimtelijke aanwezigheid',
        'Beeldhouwwerk was duurder te produceren dan schildering',
        'Schildering had geen traditie in oudheid',
        'Marmer was het enig moreel zuivere kunstmedium',
      ],
      0,
      'De Renaissance-paragone verdedigde de tastbare aanwezigheid van beeldhouwkunst tegenover het illusionisme van schildering—een hiërarchie ontleend aan Plato\'s ideeënleer.',
    ],
    [
      'Hoe weerspiegelde Michelangelo\'s theologische opvatting van de beeldhouwers rol—"bevrijding" van de figuur uit de steen—Neoplatonisch idealisme?',
      [
        'De vorm bestond al in de steen, wachtend op onthulling',
        'Michelangelo geloofde beeldhouwwerk was louter handwerk',
        'Hij verwierp alle filosofische kaders voor empirische proefneming',
        'Steen was dode materie die animatie door schildering vereiste',
      ],
      0,
      'Michelangelo beschouwde beitelen als onthulling—de ideale vorm woont al in de materie; de kunstenaar bevrijdt haar door zijn visie.',
    ],
    [
      'Welke methodologische innovatie voerde Rodin in openbare monumentpraktijk in die beeldhouwkunstbetekenis van statische herdenking naar psychologische temporaliteit verschuifde?',
      [
        'Fragmentaire, onvoltooide vormen drukten psychologische onrust uit',
        'Fotografische documentatie van het beeldhouwproces',
        'Exclusief gebruik van klassiek geïdealiseerde vormen',
        'Verwerping van alle openbare commissies ten gunste van particuliere galerijen',
      ],
      0,
      'Rodins gefragmenteerde ledematen, gestuele onvolledigheid en ruwe oppervlakken introduceerden psychologische expressiviteit.',
    ],
    [
      'Hoe beïnvloedde Brancusi\'s betrokkenheid met niet-westerse beeldhouwkunsttradities (vooral Roemeense folk en Afrikaanse) zijn theorie van "essentiële vorm"?',
      [
        'vorm komt voort uit materiaalaard, niet klassieke proportie',
        'Afrikaanse beeldhouwkunst heeft geen formele waarde en Brancusi negeerde het',
        'Niet-westerse kunst was louter decoratief zonder conceptuele diepte',
        'Brancusi converteerde deze tradities naar westerse academische normen',
      ],
      0,
      'Brancusi citeerde folk-beiteling en Afrikaans werk als bewijs dat formele kracht voortkomt uit materie-respect en spiritueel inzicht.',
    ],
    [
      'In welke zin vertegenwoordigde Donald Judds verwerping van metafoor en symbolische referentie in minimalistische beeldhouwkunst een epistemologische breuk van modernisme?',
      [
        'Het object was letterlijke, fenomenologische aanwezigheid, niet symbolisch',
        'Judds werk bevatte uitgebreide symbolische betekenis zoals alle vorige beeldhouwkunst',
        'Minimalisme was de uiteindelijke bloei van romantisch idealisme',
        'Judd probeerde klassieke allegorie te doen herleven',
      ],
      0,
      'Judds letterlijkheid verwierp de modernistische aanname dat vorm inwendige essentie uitdrukte; een kubus is een kubus.',
    ],
    [
      'Hoe herstructureerde de opkomst van industriële bronzegieterijen in 19e-eeuws Frankrijk, vooral Barbédienne en Susse Frères, de kunstenaar-ambachtsliedenverhouding?',
      [
        'Gelicenseerde maquette-naar-editie-productie',
        'Gieterijen elimineerden bronzegietwerk geheel',
        'Industriële productie had geen invloed op beeldhouwpraktijk',
        'Bronzegietwerk werd minder bekwaam en meer mechanisch',
      ],
      0,
      'Barbédienne en Susse stelden editiesystemen, licenties, kwaliteitscontrole en reproduceerbaarheid vast, en maakten beeldhouwkunst zo tot koopwaar.',
    ],
    [
      'Wat onthult het archeologisch concept van "heruitsnijding" in antieke marmerbeeldhouwkunst over continuiteitenzin-maakheid en hergebruik over Romeinse en christelijke periodes?',
      [
        'Heidense standbeelden heruitgesneden met christelijke ikonografie',
        'Heruitsnijding is louter ongeldig beschadigen',
        'Antieke beeldhouwers maakten geen wijzigingen na initiële voltooiing',
        'Christelijke ambachtslieden hadden geen kennis van klassieke techniek',
      ],
      0,
      'Heruitsnijding toont actieve culturele toe-eigening: portretten werden heiligen, oppervlakken werden opnieuw uitgesneden voor een nieuwe theologie.',
    ],
    [
      'Hoe herconfigureerde de "ontmaterialiserings"-thesis van Land Art en conceptuele beeldhouwers de ontologische status van het materialobject?',
      [
        'Efemere werken stelden concept boven het object',
        'Materiaal werd belangrijker dan ooit',
        'Conceptuele kunst elimineerde alle fysieke aanwezigheid',
        'Deze beweging keerde terug naar klassieke marmerhouwen',
      ],
      0,
      'Spiral Jetty en andere landkunstwerken wierpen de vraag op: is kunst de fysieke ingreep, de documentatie, het concept, of de ontmoeting met de toeschouwer?',
    ],
    [
      'In het kader van feministische interventies in beeldhouwkunst, hoe adresseerden kunstenaars zoals Magdalena Abakanowicz lichaam en serialiteit om heldhaftige monumenttradities te kritiseren?',
      [
        'Repetitieve, anonieme lichamen vervingen heldhaftige figuren',
        'Zij keerden terug naar geïdealiseerde klassieke naakten',
        'Feministische beeldhouwkunst verwierp alle herhaling en massaproductie',
        'Hun werk had geen verbinding met politieke kritiek',
      ],
      0,
      'Abakanowicz\' identieke koppeloze torsi in rijen roepen individu-in-massa en staatsuniformiteit op, en ondermijnen daarmee de monumenttraditie.',
    ],
    [
      'Welke theoretische implicaties stelt de conserveringsdebat rond patina-verwijdering op antieke bronzen voor de relatie tussen tijd, authenticiteit en artistieke bedoeling?',
      [
        'Blank schoonmaken wist de geschiedenis uit',
        'Alle antieke brons dient gepolijst tot nieuw uitzien',
        'Patina heeft geen historische of esthetische betekenis',
        'Conservering dient alle tijd-gebaseerde wijzigingen om te keren',
      ],
      0,
      'Moderne conserveringsethiek verwerpt "maagdelijke restauratie"—patina registreert ouderdom; verwijdering legt valse originaliteit op.',
    ],
    [
      'Hoe functioneren rooster- en jali-snijdingstradities in Indiase tempel-beeldhouwkunst als zowel structurele als geestelijke systemen die westerse scheidingen tussen ornament en vorm compliceerden?',
      [
        'Doorboorde schermen dienen visuele en devote functies',
        'Deze snijdingen zijn louter decoratief zonder diepere betekenis',
        'Indiase beeldhouwkunst heeft geen verbinding met geestelijk doel',
        'Rooster-snijding is structureel zwak en onpraktisch',
      ],
      0,
      'Jali transformeert leegte in een doorlaatbaar membraan: licht filtert erdoorheen, zicht vermenigvuldigt zich, heiligheid dringt erdoorheen—waarbij de hiërarchie tussen ornament en vorm ineenstort.',
    ],
    [
      'Wat onthult de kritische herbeoordeling van Art Deco-beeldhouwkunst over de historiografische uitsluiting van "decoratief" of "toegepaste" beeldhouwkunst van modernistische kanons?',
      [
        'fusie van fijne kunst en industrieel ontwerp',
        'Art Deco was louter commercieel zonder artistieke verdiensten',
        'Modernisme omarmde alle decoratieve tradities gelijk',
        'Deco-beeldhouwkunst is van speelgoedmassa-productie niet te onderscheiden',
      ],
      0,
      'Art Deco\'s hybride karakter—het overbruggen van fijne en toegepaste kunst—onthulde de angsten van het modernisme over commodificatie.',
    ],
    [
      'Hoe impliceren de restauratiecontroversies rond Parthenon-sculpturen en Elgin Marbles debatten over cultureel eigendom, koloniale extractie en ethiek van universele musea?',
      [
        'Retentieberoep op "globale toegang" maskeert imperiale toe-eigening',
        'Er is geen ethisch probleem met sculpturen uit oorspronkelijke plaatsen verwijderen',
        'Culturele oorsprong heeft geen invloed op waar objecten gehuisvest dienen',
        'Universele musea zijn altijd neutrale opslagplaatsen geweest',
      ],
      0,
      'De Parthenon-sculpturen zijn hier het klassieke voorbeeld: koloniale verwijderingen worden retroactief gelegitimeerd door retoriek over "behoud" en "toegang".',
    ],
    [
      'Welke methodologische uitdagingen presenteert middeleeuwse beeldhouwde figuurdetails attributie wanneer stilistische handen, werkplaatspraktijken en documentatie ijl of tegenstrijdig zijn?',
      [
        'Attributie berust op stijlmetrische en archief-analyse',
        'Middeleeuwse beeldhouwwerken komen altijd met duidelijke kunstsignaties',
        'Attributie is nooit nodig voor historisch begrip',
        'Al middeleuws werk is anoniem en opzettelijk',
      ],
      0,
      'Middeleeuwse beeldhouwkunst betwist enkelvoudig auteurschap: werkplaatstraining, gezamenlijk snijwerk en patronaatcontrole maken attributie speculatief.',
    ],
    [
      'Hoe bestrijden eigentijdse kunstenaars die 3D-scanning, digitale modellering en algoritmisch ontwerp hanteren de fenomenologische en belichaamde epistemologieën van modernistische beeldhouwkunsttheorie?',
      [
        'Digitale processen vervangen materiële intuïtie',
        'Digitale beeldhouwkunst is identiek aan handhouwen',
        'Nieuwe technologieën hebben beeldhouwpraktijk niet veranderd',
        'Algoritmisch ontwerp herstelt romantisch individualisme',
      ],
      0,
      'CAD-naar-fabricatie-systemen verdringen belichaamde kennis door algoritmische besluitvorming; de vraag wordt of de beeldhouwer nu code of materie bewerkt.',
    ],
  ],
};
